export default "/images/vendor/flag-icon-css/flags/1x1/bv.svg?976c853ae9062409996c7172b271d6bb";